import React, { useContext, useEffect } from "react";
import CloseIcon from "@material-ui/icons/Close";
import Image from "next/image";
import PuStackWhiteLogo from "../../../public/assets/images/logoDark.webp";
import PuStackLightLogo from "../../../public/assets/images/logo.webp";
import UnderReviewImage from "../../../public/assets/scholarship/scholarship_under_review.svg";
import {
  ThemeContext,
  PustackProContext,
  IntroContext,
} from "../../../context";

export default function UnderReviewScreen({ setActiveIndex }: any) {
  const [isDark] = useContext(ThemeContext).theme;
  const [, setProSliderOpen] = useContext(PustackProContext).value;
  const scholarshipJourneyRef = useContext(IntroContext).scholarshipJourneyRef;

  const handleClose = () => {
    setProSliderOpen(false);
    setActiveIndex(0);
  };

  useEffect(() => {
    if (scholarshipJourneyRef && scholarshipJourneyRef.current) {
      scholarshipJourneyRef.current.logEvent("screen_view", {
        app_name: "pustack_app",
        screen_name: "scholarship_form_submitted_screen",
      });
    }
  }, [scholarshipJourneyRef]);

  return (
    <div className="successful-submission">
      <div
        className="close__wrapper"
        onClick={() => {
          handleClose();
          // setOrderStatus(false);
        }}
        style={{ cursor: "pointer" }}
      >
        <CloseIcon className="close__icon" />
      </div>
      <div className="successful-submission-logo">
        <Image
          width={100}
          height={100}
          src={isDark ? PuStackWhiteLogo : PuStackLightLogo}
          alt="Pustack"
        />
      </div>
      <div className="successful-submission-content">
        {/*<Lottie*/}
        {/*	style={{width: '70%'}}*/}
        {/*	options={{*/}
        {/*		animationData: ScholarshipSuccessLottie,*/}
        {/*		loop: true,*/}
        {/*	}}*/}
        {/*/>*/}
        <Image
          src={UnderReviewImage}
          width={100}
          height={100}
          alt={"Scholarship under review"}
        />
        <h3>Submitted</h3>
        <p>Your application is being reviewed.</p>
      </div>
      <button
        className="successful-submission-btn"
        onClick={() => {
          handleClose();
        }}
      >
        Done
      </button>
    </div>
  );
}
